import m from 'mithril';

import { Button } from '../components/Button';
import { Type } from '../components/Typography';

/**
 * Home page.
 */
export const Home: m.Component = {
  view: () => {
    return m('section', { class: 'page page--home home-page' }, [
      m(Type, { size: 'subtitle', className: 'home-page__subtitle' }, [
        "We're building a unifying environment,",
        m('br'),
        "delivering on Alan Kay's vision",
        m('br'),
        'of computing as a New Medium.',
      ]),
      m('div', { class: 'home-page__copy' }, [
        m(Type, { className: 'home-page__paragraph' },
          'The GUI desktop is over 40 years old now. Along the way productivity documents, the Web, and SaaS apps got added on top, and now AI. Each amazing, but barely connected.'),
        m(Type, { className: 'home-page__paragraph' },
          'The Mesh environment unifies all these technologies into one platform. It provides the strong context needed for productivity and AI, giving users remarkable new power.'),
        m(Type, { className: 'home-page__paragraph' }, 'Our beta requires a Mac and is free.'),
        m(Button, {
          size: 'xl',
          className: 'home-page__cta',
          onclick: (event) => {
            event.redraw = false;
            m.route.set('/request-invite');
          },
        }, 'Join the Beta'),
      ]),
    ]);
  },
};
